
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { RadioButton } from "primereact/radiobutton";
import React from "react";
// import './styles.scss'

function PadraoCartorioDialog(props){
    const padroes_cartorio = [
        {
            name:'CENPROT',
            value:"cenprot",
            description:'Padrão CENPROT',
        },
        {
            name:'Recife',
            value:"cartorio_recife",
            description:'Padrão Pague',
        },
    ]

    return(
        <Dialog
        visible
        className="dialog-padrao"
        header="Selecionar Padrão"
        onHide={()=>props.close()}
        >
            <div>
                <h5><b>Informe em qual padrão seu arquivo está fomatado</b></h5>
                <div className="botoes">
                    {padroes_cartorio.map((tipos)=>{
                        return(
                       <div className="botao-padrao">                       
                            <RadioButton 
                            value={tipos.value} 
                            name={tipos.name} 
                            onChange={(e) => props.selectPadrao(e.value)} 
                            checked={props.padrao === tipos.value} 
                            />
                            <label>{tipos.description}</label> 
                       </div>)
                    })}
                    <div className="mt-4">
                        <Button
                        severity="success"
                        label="Enviar Arquivo"
                        icon="pi pi-upload"
                        disabled={props.padrao === ''}
                        onClick={()=>props.send()}
                        />
                    </div>
                </div>
            </div>
        </Dialog>
    )
}

export default PadraoCartorioDialog